
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/skisteder",
      function () {
        return require("private-next-pages/[region]/skisteder.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/skisteder"])
      });
    }
  